/**
 * Created by Tiger on 09/06/2022.
 */

import React, {ChangeEvent, FC, useContext, useEffect, useRef, useState} from "react";
import {Column, HCenter, PlusImage, PrimaryButton} from "./lib";
import {Button, Checkbox, InputRef, Row} from "antd";
import InputWithLabel from "./InputWithLabel";
import {Link, useHistory} from 'react-router-dom'
import i18n from "i18next";
import styled from "@emotion/styled";
import {CaretDownOutlined} from "@ant-design/icons";
import {ContextProps, MobileLoginContext} from "./index";


interface Placeholder {
  inputPlaceholder: string;
  ButtonText: string
}

interface LoginProps {
  history: {
    push(url: string): void
  }
}

const Login: FC<LoginProps> = (props) => {
  const {loginType, setLoginType, phoneCode} = useContext(MobileLoginContext) as ContextProps;
  const inputRef = useRef<InputRef>(null)
  const [placeholder, setPlaceholder] = useState<Placeholder>({
    inputPlaceholder: i18n.t('email'),
    ButtonText: i18n.t('phone_login')
  });
  const [account, setAccount] = useState('');
  const [checkedPrivacy, setCheckedPrivacy] = useState(false);
  const history = useHistory();
  useEffect(() => {
    setPlaceholder(loginType === 'Email' ? {
      inputPlaceholder: i18n.t('email'),
      ButtonText: i18n.t('phone_login')
    } : {
      inputPlaceholder: i18n.t('phone'),
      ButtonText: i18n.t('email_login')
    })
    inputRef.current?.focus()
  }, [loginType])

  const switchLoginType = () => {
    setAccount('')
    setLoginType(loginType === 'Email' ? 'Phone' : 'Email')
  }
  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const {value} = event.target
    setAccount(value)

  }
  return <Column style={{height: document.body.clientHeight, justifyContent: 'space-between'}}>
    <Column style={{marginLeft: 0, marginRight: 0}}>
      <HCenter style={{marginTop: 80,}}>
        <PlusImage/>
      </HCenter>
      <span style={{marginTop: 30, fontSize: 14, fontWeight: 700}}>{i18n.t('login_tip')}</span>
      <InputWithLabel
        onPressEnter={() => {
          inputRef.current?.blur()
          props.history.push(`/login/mobile/password/${account}/${loginType}/${phoneCode}`)
        }}
        inputMode={loginType === 'Email' ? 'email' : 'numeric'}
        value={account}
        onChange={onChange}
        prefix={loginType === 'Phone' ? <div style={{display: 'flex', alignItems: 'center'}}
                                             onClick={() => history.push('/login/mobile/selectCountryCode')}>
          <span>{`+${phoneCode}`}</span>
          <CaretDownOutlined style={{marginLeft: 5, opacity: .8}}/>
        </div> : <div/>}
        ref={inputRef}
        placeholder={placeholder.inputPlaceholder}
      />
      <Button type={"link"}
              style={{padding: 0, marginTop: 20}}
              onClick={switchLoginType}>{placeholder.ButtonText}</Button>
      <Row style={{width: '100%', marginTop: 60}} justify={'center'}>
        <Checkbox onChange={(e) => {setCheckedPrivacy(old => !old)}} value={checkedPrivacy}>{i18n.t('read_privacy')}
          <Button
            href={`https://www.qingping.co/air/privacy?lang=${i18n.language}`} target={'_blank'} style={{padding: 0,}}
            type={'link'}>{i18n.t('google_privacy2')}</Button></Checkbox>
      </Row>
      <PrimaryButton
        disabled={!checkedPrivacy || account === ''}
        type={"primary"}
        style={{marginTop: 20, height: 48}}
      >
        <Link to={`/login/mobile/password/${account}/${loginType}/${phoneCode}`}>{i18n.t('next')}</Link>
      </PrimaryButton>
    </Column>
    {/*<Text> {i18n.t('login_tip2')}</Text>*/}
  </Column>

}

const Text = styled.div`
  color: #000000;
  opacity: .5;
  font-size: 11px;
  margin-bottom: 20px;
  margin-top: 40px;
`
export default Login
